import React, { useState, useEffect } from "react";
import axios from "axios";
import dataEn from "../dataEn";
import dataKin from "../dataKin";
import { language } from "../tools/language";
import API_BASE_URL from "../config";  // ADD THIS LINE

const data = language === "en" ? dataEn : dataKin;

const UpdateStatus = ({ christian, onUpdate, onCancel }) => {
  const [status, setStatus] = useState(christian?.status || '');

  useEffect(() => {
    if (christian) {
      setStatus(christian.status || '');
    }
  }, [christian]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.put(
        `${API_BASE_URL}/christian/update/${christian.id}`,  // CHANGE THIS LINE
        { status }
      );
      onUpdate();
    } catch (error) {
      console.error("Error updating status:", error);
      alert("Failed to update status. Check console for details.");
    }
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      <div className="mb-4">
        <p className="text-sm font-medium text-gray-700 mb-1">Current Status:</p>
        <p className="text-lg font-semibold">
          <span className={`px-2 py-1 rounded-full text-sm ${
            christian?.status === 'Active' ? 'bg-green-100 text-green-800' :
            christian?.status === 'Inactive' ? 'bg-yellow-100 text-yellow-800' :
            christian?.status === 'Visitors' ? 'bg-blue-100 text-blue-800' :
            christian?.status === 'Punished' ? 'bg-red-100 text-red-800' :
            christian?.status === 'Nolonger' ? 'bg-gray-100 text-gray-800' :
            'bg-gray-100 text-gray-800'
          }`}>
            {christian?.status || 'Unknown'}
          </span>
        </p>
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {data.allChristianTable.status}
        </label>
        <select
          value={status}
          onChange={(e) => setStatus(e.target.value)}
          className="w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-blue-500 focus:border-blue-500"
        >
          <option value="">Select status</option>
          <option value="Active">Active</option>
          <option value="Inactive">Inactive</option>
          <option value="Visitors">Visitors</option>
          <option value="Punished">Punished</option>
          <option value="Nolonger">No Longer Member</option>
        </select>
      </div>

      <div className="flex justify-end space-x-3 mt-6">
        <button
          type="button"
          onClick={onCancel}
          className="px-4 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50"
        >
          Cancel
        </button>
        <button
          type="submit"
          className="px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-blue-600 hover:bg-blue-700"
        >
          Update Status
        </button>
      </div>
    </form>
  );
};

export default UpdateStatus;